var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2292_12505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2292_12505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99998 16.8077C3.58461 16.7564 3.23077 16.5702 2.93845 16.249C2.64615 15.9279 2.5 15.55 2.5 15.1154V7.36153C2.5 7.14999 2.55802 6.94744 2.67405 6.75385C2.79007 6.56027 2.95384 6.40643 3.16537 6.29233L10.75 2.5L18.1846 6.29233C18.359 6.37309 18.5025 6.50578 18.6154 6.69038C18.7282 6.87499 18.8064 7.06794 18.85 7.26923H16.8193L10.75 4.19228L3.99998 7.5423V16.8077ZM7.1923 20.5C6.68717 20.5 6.25961 20.325 5.90963 19.975C5.55963 19.625 5.38463 19.1974 5.38463 18.6923V10.4616C5.38463 9.95642 5.55963 9.52886 5.90963 9.17888C6.25961 8.82888 6.68717 8.65388 7.1923 8.65388H19.6923C20.1974 8.65388 20.625 8.82888 20.975 9.17888C21.325 9.52886 21.5 9.95642 21.5 10.4616V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H7.1923ZM13.4423 15.0423L6.88458 11.6923V18.6923C6.88458 18.782 6.91343 18.8557 6.97113 18.9134C7.02883 18.9711 7.10255 19 7.1923 19H19.6923C19.782 19 19.8557 18.9711 19.9134 18.9134C19.9711 18.8557 20 18.782 20 18.6923V11.6923L13.4423 15.0423ZM13.4423 13.5038L19.8846 10.2115C19.8525 10.1923 19.8221 10.1779 19.7932 10.1683C19.7644 10.1586 19.7307 10.1538 19.6923 10.1538H7.1923C7.16025 10.1538 7.12819 10.1586 7.09613 10.1683C7.06408 10.1779 7.03203 10.1923 6.99998 10.2115L13.4423 13.5038Z",
    fill: "#AFAFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconGray);
export default __webpack_public_path__ + "static/media/mail-icon-gray.43ddbfec35a06b24816dea09e716b6a9.svg";
export { ForwardRef as ReactComponent };